import React, { StrictMode } from "react"
import ReactDOM from "react-dom/client"
import "./index.css"

import { ErrorBoundary, FallbackProps } from "react-error-boundary"
import { RouterProvider } from "react-router-dom"

import { AnimatePresence } from "framer-motion"

import PermissionsInitializer from "./hooks/permissions"
import GeneralError from "./pages/Errors/GeneralError"
import Providers from "./providers"
import router from "./router"

const ErrorFallback: React.FC<FallbackProps> = () => {
  return <GeneralError />
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <AnimatePresence mode="wait">
          <PermissionsInitializer />
          <RouterProvider router={router} />
        </AnimatePresence>
      </ErrorBoundary>
    </Providers>
  </StrictMode>
)
